import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rlhn9yr23: FaireProductEntity = {
  token: "p_7rlhn9yr23",
  type: "product",
  name: "Still Rolling Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e8012cdf4160c559bbb39f9773c3079a1e068a628c853e4189aea2b21f726e28.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d19c5134afae4ef968a87c093a2703ff5f7ae4cc8774fdb111d3eed049c4c169.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:02.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
